export default "__VITE_ASSET__DIyzHquX__"